import request from '../services/request';

export const getSections = () => request.get('/sections');
export const getSectionContent = ({
  sectionId,
  type,
  page,
  limit,
}) => request.get(`/sections/content/${sectionId}`, {
  params: {
    content_type: type,
    page,
    limit,
  },
});
